<template>
	<div class="codemirror-container">
		<codemirror ref="editor" v-model="code" :options="options" :mode="mode" />
	</div>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/TaskManagement/store/helpers';
import { codemirror } from 'vue-codemirror';
import CodeMirror from 'codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/clike/clike';
import 'codemirror/addon/comment/comment';
import 'codemirror/addon/lint/lint';
import 'codemirror/addon/lint/lint.css';
import 'codemirror/addon/fold/brace-fold';
import 'codemirror/addon/fold/comment-fold';
import 'codemirror/addon/fold/foldcode';
import 'codemirror/addon/fold/indent-fold';
import 'codemirror/addon/edit/closebrackets';
import 'codemirror/addon/edit/closetag';
import 'codemirror/addon/display/fullscreen.css';
import 'codemirror/addon/display/fullscreen';
import 'codemirror/theme/cobalt.css';
import 'codemirror/addon/hint/show-hint';
import 'codemirror/addon/hint/show-hint.css';
import 'codemirror/addon/selection/active-line';
import 'codemirror/addon/selection/mark-selection';
import 'codemirror/addon/selection/selection-pointer';
import 'codemirror/addon/search/matchesonscrollbar';
import 'codemirror/addon/search/match-highlighter';
import 'codemirror/addon/search/searchcursor';
import 'codemirror/addon/search/search';
import 'codemirror/addon/search/jump-to-line';
import _ from 'lodash';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {
		codemirror
	},
	mounted() {
		this.onCodemirrorLoaded();
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		codemirror() {
			return this.$refs.editor.codemirror;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onCodemirrorLoaded() {
			const autocomplete = function (cm) {
				CodeMirror.showHint(
					cm,
					function () {
						const doc = cm.getDoc();
						const line = cm.getCursor().line;
						const ch = cm.getCursor().ch;
						const chFrom = cm.findWordAt({ line, ch }).anchor.ch;
						const chTo = cm.findWordAt({ line, ch }).head.ch;
						const tok = cm.getRange({ line, ch: chFrom }, { line, ch: chTo });

						const text = doc.getValue();
						return {
							from: CodeMirror.Pos(line, chFrom),
							to: CodeMirror.Pos(line, chTo),
							list: _.uniq(text.replace(/[^a-z|^A-Z|^0-9]/gi, ' ').split(' '))
								.filter(str => str.localeCompare(tok) !== 0 && new RegExp(`^${tok}`).test(str))
								.sort()
						};
					},
					{ completeSingle: false, closeOnUnfocus: true }
				);
			};
			CodeMirror.commands.autocomplete = autocomplete;
			this.codemirror.on('keyup', function (cm, event) {
				if (/^[a-z0-9]{1}$/gi.test(event.key)) {
					autocomplete(cm);
				}
			});
			this.DEFAULT_ASSIGN({
				key: 'codemirror',
				value: this.codemirror
			});
		}
	},
	data() {
		return {
			options: {
				tabSize: 4,
				indentUnit: 4,
				styleActiveLine: true,
				lineNumbers: true,
				line: true,
				mode: 'text/x-java',
				lineWrapping: true,
				matchBrackets: true,
				autoCloseBrackets: true,
				autoCloseTags: true,
				autofocus: true,
				foldGutter: true,
				theme: 'cobalt',
				gutters: ['CodeMirror-linenumbers', 'CodeMirror-lint-markers'], //'CodeMirror-foldgutter',
				lint: true,
				extraKeys: {
					'Ctrl-Space': 'autocomplete',
					'Ctrl-F': 'findPersistent',
					'Ctrl-/': 'toggleComment',
					F11: function (cm) {
						cm.setOption('fullScreen', !cm.getOption('fullScreen'));
					}
				},
				styleActiveLine: true,
				showHint: true,
				markSelection: true,
				selectionPointer: 'pointer',
				highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true },
				lineWiseCopyCut: true,
				onLoad: this.onCodemirrorLoaded
			},
			mode: 'edit',
			styleActiveLine: true,
			code: ''
		};
	}
};
</script>
<style>
.codemirror-container {
	width: 100% !important;
	height: 100%;
}
.vue-codemirror {
	height: 100%;
}
.CodeMirror.CodeMirror-wrap {
	height: 500px;
	/* height: 100%; */
}
.CodeMirror {
	border-top: 1px solid black;
	border-bottom: 1px solid black;
}
.CodeMirror-focused .cm-matchhighlight {
	background-position: bottom;
	background-repeat: repeat-x;
}
.cm-matchhighlight {
	background-color: blue;
}
.CodeMirror-selection-highlight-scrollbar {
	background-color: green;
}
.CodeMirror-dialog.CodeMirror-dialog-top {
	position: absolute;
	top: 0;
	right: 18px;
	background: white;
	border: 1px solid black;
	width: 30%;
	min-width: 20rem;
	color: black;
	padding: 5px;
	border-radius: 5px;
}
.CodeMirror-dialog.CodeMirror-dialog-top input {
	border: 1px solid lightgray;
}
</style>
